import type React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useAuth } from '../../contexts/AuthContext'
import { theme } from '../../theme/theme'
import { ChangePasswordForm } from './ChangePasswordForm'
import { LoginForm } from './LoginForm'

const AuthContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${theme.spacing.md};
`

const AuthContent = styled.div`
  width: 100%;
  max-width: 500px;
`

export const AuthPage: React.FC = () => {
  const { isPasswordRecovery } = useAuth()
  const [isSignUp, setIsSignUp] = useState(false)
  const navigate = useNavigate()

  const toggleMode = () => {
    if (!isSignUp) {
      // User wants to sign up - navigate to role selection
      navigate('/role-selection')
    } else {
      // User wants to switch back to login
      setIsSignUp(false)
    }
  }

  return (
    <AuthContainer>
      <AuthContent>
        {isPasswordRecovery ? <ChangePasswordForm /> : <LoginForm onToggleMode={toggleMode} isSignUp={isSignUp} />}
      </AuthContent>
    </AuthContainer>
  )
}
